/* ============================================================================
FILE: po-katupirsia5-katuvysissence-texts-fr-en-es-20260303.js
MODE: JS FR/EN/ES (injection tri) + lexicon override (termes FR) si présent
API:  window.PoKatupirsia5KatuvysissenceTextsFR_EN_ES_20260303
============================================================================ */

(function(){
  "use strict";

  if (window.__PO_K5_KATUVYSISSENCE_TEXTS_20260303__) return;
  window.__PO_K5_KATUVYSISSENCE_TEXTS_20260303__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var AXIS_LEX_ID = "katuvysissence";
  var ROOT_SEL =
    '.po-axis-section[data-po-axis][data-po-lex-id="' + AXIS_LEX_ID + '"], ' +
    '.po-axis-section[data-po-axis="' + AXIS_LEX_ID + '"], ' +
    '.po-axis-section[data-po-lex-id="' + AXIS_LEX_ID + '"]';

  function clampStr(v){ return (v == null) ? "" : String(v); }
  function qsa(root, sel){ try{ return Array.prototype.slice.call(root.querySelectorAll(sel)); }catch(e){ return []; } }

  function normLang(raw){
    var s = clampStr(raw).toLowerCase().trim();
    if (s === "fr" || s === "en" || s === "es") return s;
    return "fr";
  }

  function readStoredLang(){
    var v = "";
    try{ v = localStorage.getItem(STORAGE_KEY) || ""; }catch(e){ v = ""; }
    if (!v){
      try{ v = localStorage.getItem(STORAGE_KEY_COMPAT) || ""; }catch(_e){ v = ""; }
    }
    return normLang(v || "fr");
  }

  function storeLang(lang){
    var l = normLang(lang);
    try{ localStorage.setItem(STORAGE_KEY, l); }catch(e){}
    try{ localStorage.setItem(STORAGE_KEY_COMPAT, l); }catch(_e){}
    try{
      if (document && document.documentElement){
        document.documentElement.setAttribute("lang", l);
      }
    }catch(__e){}
    return l;
  }

  function getLang(){ return readStoredLang(); }

  function notifyLocaleChanged(){
    try{
      window.dispatchEvent(new Event("po:locale-changed"));
    }catch(e){
      try{
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      }catch(_e){}
    }
  }

  /* --------------------------------------------------------------------------
   * LEXIQUE RUNTIME
   * -------------------------------------------------------------------------- */

  function getLexiconEntry(id){
    try{
      if (window.PO_LEXICON_MAP && window.PO_LEXICON_MAP[id]) return window.PO_LEXICON_MAP[id];
    }catch(e){}
    try{
      var arr = window.PO_LEXICON;
      if (Array.isArray(arr)){
        for (var i=0;i<arr.length;i++){
          if (arr[i] && arr[i].id === id) return arr[i];
        }
      }
    }catch(e){}
    return null;
  }

  function pickTerm(entry, lang){
    if (!entry) return "";
    try{
      if (entry.terms && entry.terms[lang]) return clampStr(entry.terms[lang]);
    }catch(e){}
    return "";
  }

  function pickAny(entry, key, fallback){
    try{
      if (entry && entry[key] != null) return entry[key];
    }catch(e){}
    return fallback;
  }

  /* --------------------------------------------------------------------------
   * PROTECTION fine (DOM-safe)
   * -------------------------------------------------------------------------- */

  function escapeHTML(s){
    return clampStr(s)
      .replace(/&/g,"&amp;")
      .replace(/</g,"&lt;")
      .replace(/>/g,"&gt;")
      .replace(/"/g,"&quot;")
      .replace(/'/g,"&#39;");
  }

  function escapeRegExp(s){
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function uniqPush(arr, v, seen){
    var k = String(v || "");
    if (!k) return;
    if (seen[k]) return;
    seen[k] = true;
    arr.push(k);
  }

  function buildVariants(term){
    var out = [];
    var seen = Object.create(null);
    var t = clampStr(term);
    if (!t) return out;

    uniqPush(out, t, seen);
    uniqPush(out, t.replace(/’/g, "'"), seen);
    uniqPush(out, t.replace(/'/g, "’"), seen);
    uniqPush(out, t.replace(/œ/g, "oe").replace(/Œ/g, "OE"), seen);
    uniqPush(out, t.replace(/oe/g, "œ").replace(/OE/g, "Œ"), seen);

    var oe1 = t.replace(/œ/g, "oe").replace(/Œ/g, "OE");
    var oe2 = t.replace(/oe/g, "œ").replace(/OE/g, "Œ");
    uniqPush(out, oe1.replace(/’/g, "'"), seen);
    uniqPush(out, oe1.replace(/'/g, "’"), seen);
    uniqPush(out, oe2.replace(/’/g, "'"), seen);
    uniqPush(out, oe2.replace(/'/g, "’"), seen);

    return out;
  }

  function getSimplifiedLexiqueFRList(){
    try{
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)){
        return window.PO_LEXICON_META.lexique_simplifie_fr.slice();
      }
    }catch(e){}
    try{
      if (window.PO_LEXICON && window.PO_LEXICON.meta && Array.isArray(window.PO_LEXICON.meta.lexique_simplifie_fr)){
        return window.PO_LEXICON.meta.lexique_simplifie_fr.slice();
      }
    }catch(e){}
    return [];
  }

  function buildProtectRegexFromSimplified(){
    var base = getSimplifiedLexiqueFRList();
    if (!base || !base.length) return null;

    var terms = [];
    var seen = Object.create(null);

    for (var i=0;i<base.length;i++){
      var vars = buildVariants(base[i]);
      for (var j=0;j<vars.length;j++){
        uniqPush(terms, vars[j], seen);
      }
    }

    terms.sort(function(a,b){ return b.length - a.length; });

    var parts = [];
    for (var k=0;k<terms.length;k++){
      parts.push(escapeRegExp(terms[k]));
    }
    if (!parts.length) return null;

    try{
      return new RegExp("(" + parts.join("|") + ")", "g");
    }catch(e){
      return null;
    }
  }

  var __PO_PROTECT_CACHE__ = { key:"", re:null };

  function ensureProtectEngineReady(){
    var key = "meta:none";
    try{
      var l = getSimplifiedLexiqueFRList();
      key = "meta:" + (l ? l.length : 0);
    }catch(e){
      key = "meta:none";
    }
    if (__PO_PROTECT_CACHE__.key === key) return;
    __PO_PROTECT_CACHE__.key = key;
    __PO_PROTECT_CACHE__.re = buildProtectRegexFromSimplified();
  }

  function isLockedElement(el){
    if (!el || el.nodeType !== 1) return false;
    var tr = el.getAttribute && el.getAttribute("translate");
    if (tr && String(tr).toLowerCase() === "no") return true;
    var cls = el.className || "";
    if (typeof cls === "string"){
      if (cls.indexOf("notranslate") !== -1) return true;
      if (cls.indexOf("po-lex-protect") !== -1) return true;
      if (cls.indexOf("po-lex-locknode") !== -1) return true;
    }
    return false;
  }

  function isLockedNode(node){
    var el = (node && node.nodeType === 1) ? node : (node ? node.parentElement : null);
    while (el && el.nodeType === 1){
      if (isLockedElement(el)) return true;
      el = el.parentElement;
    }
    return false;
  }

  function isWordLikeChar(ch){
    return /[0-9A-Za-zÀ-ÖØ-öø-ÿ_]/.test(ch);
  }

  function protectTextNode(doc, textNode){
    ensureProtectEngineReady();
    var re = __PO_PROTECT_CACHE__.re;
    if (!re) return;

    var txt = textNode.nodeValue;
    if (!txt) return;

    re.lastIndex = 0;
    if (!re.test(txt)) return;

    re.lastIndex = 0;
    var frag = doc.createDocumentFragment();
    var last = 0;
    var m;

    while ((m = re.exec(txt)) !== null){
      var start = m.index;
      var match = m[0];
      var end = start + match.length;

      if (start > last){
        frag.appendChild(doc.createTextNode(txt.slice(last, start)));
      }

      var chPrev = (start - 1 >= 0) ? txt.charAt(start - 1) : "";
      if (chPrev && isWordLikeChar(chPrev)){
        frag.appendChild(doc.createTextNode(" "));
      }

      var span = doc.createElement("span");
      span.setAttribute("translate", "no");
      span.className = "po-lex-protect notranslate";
      span.textContent = match;
      frag.appendChild(span);

      var chNext = (end < txt.length) ? txt.charAt(end) : "";
      if (chNext && isWordLikeChar(chNext)){
        frag.appendChild(doc.createTextNode(" "));
      }

      last = end;
      if (match.length === 0) break;
    }

    if (last < txt.length){
      frag.appendChild(doc.createTextNode(txt.slice(last)));
    }

    if (textNode.parentNode){
      textNode.parentNode.replaceChild(frag, textNode);
    }
  }

  function protectKeywordsHTML(html){
    if (!html) return "";
    ensureProtectEngineReady();
    if (!__PO_PROTECT_CACHE__.re) return String(html);

    var tpl = document.createElement("template");
    tpl.innerHTML = String(html);
    var root = tpl.content || tpl;

    var walker;
    try{
      walker = document.createTreeWalker(
        root,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode: function(n){
            if (!n || !n.nodeValue) return NodeFilter.FILTER_REJECT;
            if (isLockedNode(n)) return NodeFilter.FILTER_REJECT;
            return NodeFilter.FILTER_ACCEPT;
          }
        },
        false
      );
    }catch(e){
      return String(html);
    }

    var nodes = [];
    var n;
    while ((n = walker.nextNode())) nodes.push(n);

    for (var i=0;i<nodes.length;i++){
      protectTextNode(document, nodes[i]);
    }

    return tpl.innerHTML;
  }

  /* --------------------------------------------------------------------------
   * AUDIO
   * -------------------------------------------------------------------------- */

  var PO_AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis) ? window.speechSynthesis : null;
  var PO_AUDIO_STATE = {
    root: null,
    units: [],
    unitPos: -1,
    chunks: [],
    chunkPos: -1,
    activeKey: ""
  };

  var AUDIO_UI = {
    fr: { general: "Écouter le texte", block: "Écouter ce bloc", stop: "Arrêter la lecture" },
    en: { general: "Listen to the text", block: "Listen to this section", stop: "Stop playback" },
    es: { general: "Escuchar el texto", block: "Escuchar este bloque", stop: "Detener la lectura" }
  };

  function audioUI(lang){
    return AUDIO_UI[normLang(lang)] || AUDIO_UI.fr;
  }

  function ensureAudioStyles(){
    if (document.getElementById("po-k5-katuvysissence-audio-styles")) return;
    var style = document.createElement("style");
    style.id = "po-k5-katuvysissence-audio-styles";
    style.textContent = [
      '.po-axis-audio-wrap{display:flex;justify-content:center;margin:12px 0 14px;}',
      '.po-audio-btn{appearance:none;-webkit-appearance:none;border:1px solid rgba(0,0,0,.14);background:rgba(0,0,0,.02);color:inherit;border-radius:999px;padding:8px 14px;font:inherit;font-size:12px;line-height:1;cursor:pointer;transition:transform .18s ease,box-shadow .18s ease,border-color .18s ease,background .18s ease;}',
      '.po-audio-btn:hover{transform:translateY(-1px);box-shadow:0 8px 18px rgba(0,0,0,.08);border-color:rgba(0,0,0,.24);}',
      '.po-audio-btn.is-active{border-color:rgba(184,134,11,.55);box-shadow:0 0 0 1px rgba(184,134,11,.18),0 8px 18px rgba(31,122,58,.10);font-weight:700;}',
      '.po-lex-summary .po-audio-btn{margin-left:auto;flex:0 0 auto;}',
      '@media (max-width:640px){.po-lex-summary{flex-wrap:wrap;}.po-lex-summary .po-audio-btn{order:3;margin-left:0;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function createAudioButton(role){
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "po-audio-btn notranslate";
    btn.setAttribute("translate", "no");
    btn.setAttribute("data-po-audio-role", role);
    return btn;
  }

  function ensureAudioButtons(root, lang){
    if (!root) return;
    ensureAudioStyles();

    var panel = root.querySelector(".po-lex-panel");
    if (panel){
      var generalWrap = root.querySelector(".po-axis-audio-wrap[data-po-audio-role='general']");
      if (!generalWrap){
        generalWrap = document.createElement("div");
        generalWrap.className = "po-axis-audio-wrap notranslate";
        generalWrap.setAttribute("translate", "no");
        generalWrap.setAttribute("data-po-audio-role", "general");
        generalWrap.appendChild(createAudioButton("general"));

        var meta = root.querySelector(".po-axis-meta");
        var defShort = root.querySelector("[data-po-slot='def_short']");
        var firstDetail = panel.querySelector(".po-lex-details");
        if (meta && meta.parentNode){
          if (meta.nextSibling) meta.parentNode.insertBefore(generalWrap, meta.nextSibling);
          else meta.parentNode.appendChild(generalWrap);
        }else if (defShort && defShort.parentNode){
          defShort.parentNode.insertBefore(generalWrap, defShort);
        }else if (firstDetail && firstDetail.parentNode){
          firstDetail.parentNode.insertBefore(generalWrap, firstDetail);
        }else{
          panel.appendChild(generalWrap);
        }
      }
    }

    qsa(root, ".po-lex-details").forEach(function(details, idx){
      var summary = details.querySelector(".po-lex-summary");
      if (!summary) return;
      var btn = summary.querySelector(".po-audio-btn[data-po-audio-role='block']");
      if (!btn){
        btn = createAudioButton("block");
        btn.setAttribute("data-po-audio-index", String(idx));
        summary.appendChild(btn);
      }else{
        btn.setAttribute("data-po-audio-index", String(idx));
      }
    });

    bindAudioButtons(root, lang);
  }

  function refreshAudioButtons(root, lang){
    var ui = audioUI(lang);
    qsa(root, ".po-audio-btn").forEach(function(btn){
      var role = btn.getAttribute("data-po-audio-role");
      var key = role === "general" ? "general" : ("block:" + (btn.getAttribute("data-po-audio-index") || "0"));
      var active = (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === key);
      btn.textContent = active ? ui.stop : (role === "general" ? ui.general : ui.block);
      btn.classList.toggle("is-active", !!active);
      btn.setAttribute("aria-pressed", active ? "true" : "false");
    });
  }

  function bindAudioButtons(root, lang){
    qsa(root, ".po-audio-btn").forEach(function(btn){
      if (btn.__poAudioBound) return;
      btn.__poAudioBound = true;
      btn.addEventListener("click", function(ev){
        ev.preventDefault();
        ev.stopPropagation();
        var role = btn.getAttribute("data-po-audio-role");
        var key = role === "general" ? "general" : ("block:" + (btn.getAttribute("data-po-audio-index") || "0"));
        if (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === key){
          stopAudio();
          refreshAudioButtons(root, getLang());
          return;
        }
        startAudio(root, getLang(), key);
      });
    });
  }

  function textFromNode(node){
    if (!node) return "";
    var clone = node.cloneNode(true);
    qsa(clone, "script,style,.po-audio-btn,.po-lex-summary__hint").forEach(function(el){
      if (el && el.parentNode) el.parentNode.removeChild(el);
    });
    var txt = (clone.innerText || clone.textContent || "")
      .replace(/\s+/g, " ")
      .replace(/\s([:;!?])/g, "$1")
      .trim();
    return txt;
  }

  function buildIntroText(root){
    var parts = [];
    ["title","kicker","h_def","def_short","def_long"].forEach(function(slot){
      var node = root.querySelector("[data-po-slot='" + slot + "']");
      var txt = textFromNode(node);
      if (txt) parts.push(txt);
    });
    var meta = root.querySelector(".po-axis-meta");
    var metaTxt = textFromNode(meta);
    if (metaTxt) parts.push(metaTxt);
    return parts.join(". ");
  }

  function buildBlockText(details){
    if (!details) return "";
    var parts = [];
    var summary = details.querySelector(".po-lex-summary");
    if (summary){
      var title = textFromNode(summary.querySelector(".po-lex-summary__title"));
      if (title) parts.push(title);
    }
    var clone = details.cloneNode(true);
    clone.open = true;
    qsa(clone, ".po-audio-btn,.po-lex-summary__hint").forEach(function(el){
      if (el && el.parentNode) el.parentNode.removeChild(el);
    });
    var txt = textFromNode(clone);
    if (txt) parts.push(txt);
    return parts.join(". ");
  }

  function splitTextForSpeech(text){
    var raw = clampStr(text).replace(/\s+/g, " ").trim();
    if (!raw) return [];
    var sentences = raw.match(/[^.!?]+[.!?…]?/g) || [raw];
    var chunks = [];
    var current = "";
    sentences.forEach(function(sentence){
      var s = sentence.trim();
      if (!s) return;
      if (!current){
        current = s;
        return;
      }
      if ((current + " " + s).length <= 210){
        current += " " + s;
      } else {
        chunks.push(current);
        current = s;
      }
    });
    if (current) chunks.push(current);
    return chunks;
  }

  function pickVoice(lang){
    if (!PO_AUDIO_SYNTH || !PO_AUDIO_SYNTH.getVoices) return null;
    var voices = PO_AUDIO_SYNTH.getVoices() || [];
    var targets = lang === "en" ? ["en"] : (lang === "es" ? ["es"] : ["fr"]);
    for (var i=0;i<voices.length;i++){
      var vlang = clampStr(voices[i].lang).toLowerCase();
      for (var j=0;j<targets.length;j++){
        if (vlang.indexOf(targets[j]) === 0) return voices[i];
      }
    }
    return voices[0] || null;
  }

  function stopAudio(){
    if (PO_AUDIO_SYNTH) {
      try { PO_AUDIO_SYNTH.cancel(); } catch(e){}
    }
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = "";
    qsa(document, ROOT_SEL).forEach(function(root){ refreshAudioButtons(root, getLang()); });
  }

  function speakNextChunk(lang){
    if (!PO_AUDIO_SYNTH || !PO_AUDIO_STATE.chunks.length) {
      speakNextUnit(lang);
      return;
    }
    PO_AUDIO_STATE.chunkPos += 1;
    if (PO_AUDIO_STATE.chunkPos >= PO_AUDIO_STATE.chunks.length){
      speakNextUnit(lang);
      return;
    }
    var utter = new SpeechSynthesisUtterance(PO_AUDIO_STATE.chunks[PO_AUDIO_STATE.chunkPos]);
    var voice = pickVoice(lang);
    if (voice) utter.voice = voice;
    utter.lang = lang === "en" ? "en-US" : (lang === "es" ? "es-ES" : "fr-FR");
    utter.onend = function(){ speakNextChunk(lang); };
    utter.onerror = function(){ speakNextChunk(lang); };
    try { PO_AUDIO_SYNTH.speak(utter); } catch(e){ speakNextChunk(lang); }
  }

  function speakNextUnit(lang){
    PO_AUDIO_STATE.unitPos += 1;
    if (PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length){
      stopAudio();
      return;
    }
    var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
    if (unit.node && unit.node.tagName && unit.node.tagName.toLowerCase() === "details"){
      unit.node.open = true;
    }
    PO_AUDIO_STATE.chunks = splitTextForSpeech(unit.text);
    PO_AUDIO_STATE.chunkPos = -1;
    speakNextChunk(lang);
  }

  function buildUnits(root, key){
    var units = [];
    if (key === "general"){
      var intro = buildIntroText(root);
      if (intro) units.push({ key:"general", node: root, text: intro });
      qsa(root, ".po-lex-details").forEach(function(details, idx){
        var txt = buildBlockText(details);
        if (txt) units.push({ key:"block:" + idx, node: details, text: txt });
      });
      return units;
    }
    var idx = parseInt(String(key).split(":")[1], 10);
    if (isNaN(idx)) idx = 0;
    qsa(root, ".po-lex-details").forEach(function(details, pos){
      if (pos < idx) return;
      var txt = buildBlockText(details);
      if (txt) units.push({ key:"block:" + pos, node: details, text: txt });
    });
    return units;
  }

  function startAudio(root, lang, key){
    if (!PO_AUDIO_SYNTH){
      refreshAudioButtons(root, lang);
      return;
    }
    try { PO_AUDIO_SYNTH.cancel(); } catch(e){}
    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.units = buildUnits(root, key);
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = key;
    refreshAudioButtons(root, lang);
    if (!PO_AUDIO_STATE.units.length){
      stopAudio();
      return;
    }
    speakNextUnit(lang);
  }

  if (PO_AUDIO_SYNTH && PO_AUDIO_SYNTH.onvoiceschanged !== undefined) {
    PO_AUDIO_SYNTH.onvoiceschanged = function(){
      qsa(document, ROOT_SEL).forEach(function(root){ refreshAudioButtons(root, getLang()); });
    };
  }

  /* --------------------------------------------------------------------------
   * TEXTES TRI (Katûvýsissence)
   * -------------------------------------------------------------------------- */

  var IMG_IDEOGRAM_CONCEPT = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Katuvysissence_copie.png?v=1772885892";
  var IMG_ELEMENT = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Katuvys_copie.png?v=1750254535";
  var IMG_TOTEM = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Ekho.png?v=1773404195";
  var IMG_FREQ_193 = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_193.png?v=1773410300";

  var FALLBACK = {
    fr: {
      title: "Katûvýsissence",
      kicker:
        "Extrait du <em>Katûpirsia&nbsp;5 - La Matrice-substrat</em><br />(Katûsýs : mémoire spiralée transmutative — stabilisation lente)",
      h_def: "Définition opérative",
      chips: ["Élément", "Totem", "Fréquence"],
      def_short:
        "Substance mémorielle condensée de la Katûvýs : archive énergétique vivante qui stabilise en spirale, conserve la trace sans la figer, et rend réactivables les passages, seuils et syntonies comme réserve de recomposition.",
      def_long:
        "Katûvýsissence désigne la substance mémorielle condensée de la Katûvýs : une spirale vibratoire de stabilisation, une zone d’enregistrement actif des modulations, des seuils et des syntonies qui traversent le système posœnnoïal. Elle agit comme résonance lente, régulation différée, dépôt transmissible — sans figer.\n\n" +
        "Par son architecture spiralée, elle conserve les traces vibratoires des traversées opérées, et peut restituer une configuration antérieure ou catalyser l’émergence d’une nouvelle syntonie à partir d’un rythme mémorisé. Elle travaille comme réserve structurante : mémoire transmutative, base des pratiques (Accords et Méditations posœnnoïales), réservoir des univers (Posœnnoïamie / Posœnnomia), stabilisateur spiralé des oscillations, substrat du devenir.\n\n" +
        "Associée au nombre-guide 193, elle tient une fréquence de stabilisation vivante : germe (1), achèvement spiralé (9), modulation interne (3) — mémoire respirante, extratinriorale, spiralée. Elle oriente, répartit, transmet, plutôt que totaliser.",
      h_features: "Schématisation",
      h_questions: "Repères d’activation",
      hint_fold: "déplier",
      hint_fold2: "déplier",
      hint_fold3: "déplier",
      example_title: "Ex.",
      example:
        "Après un passage intense (œuvre, rituel, seuil vécu), quand tu veux « conserver la trace sans la figer » et rendre la mémoire réactivable : « Katûvýsissence stabilise ». La trace devient réserve, le souvenir devient germe de relance.",
      features: [
        "Statut : substance mémorielle condensée ; archive énergétique vivante ; résonance lente.",
        "Fonctions : mémoire transmutative ; base des pratiques ; réservoir des univers ; stabilisateur spiralé ; substrat du devenir.",
        "Rôle : retenir sans figer ; canaliser sans clore ; contenir sans résorber ; redistribuer ou métamorphoser l’excès vibratoire.",
        "Interactions : archive les trajectoires (Lulæṣírasen) ; stabilise les syntonies de croisement (Taxiêlîs) ; régule les micro-motifs (Tiqqunbahu) ; ancre les ajustements (Takimarah) ; enregistre les franchissements (Extratinrieur) ; soutient l’ajustement du sens (MOPo) ; accueille les traces de passage (Ušôprogalenmestûd).",
        "Opposition fonctionnelle : Katûvýsissence (substance stable) / Ušôprogalenmestûd (onde transitoire)."
      ],
      questions: [
        "Quelle trace doit être reçue sans être fétichisée : que faut-il stabiliser en spirale plutôt que figer ?",
        "De quel passage la mémoire doit-elle devenir réserve (et non simple archive) ?",
        "Quel excès vibratoire doit être absorbé, redistribué, ou métamorphosé pour préserver la tenue du champ ?",
        "Quelle relance veux-tu rendre possible : restitution d’un rythme, ou émergence d’une syntonie nouvelle ?"
      ],
      h_family: "Syntonie symbolique & relations systémiques",
      family_1:
        "<p><strong>Syntonie symbolique (K5) :</strong> Ākāśa (mémoire cosmique), Yesod (réservoir/canal), Bindu (germe condensé), Maât (équilibre régulateur). Ces figures éclairent une mémoire vivante : dépôt, transmission, régulation, relance.</p>",
      family_2:
        "<p><strong>Relations systémiques :</strong> Katûvýsissence agit comme structure sous-jacente régulatrice : elle recueille les effets des autres organes de Katûsýs, les stabilise en spirale, puis les rend disponibles à la recomposition (Synchrêssions, Katûpirsia, Katûvýsqun).</p>",
      h_wordbuild: "Construction (Katûvýs + –issence) & fréquence 193",
      word_blocks: [
        {
          head: "Katûvýs — noyau matriciel",
          text:
            "Champ vibratoire fluide : émergence, modulation, transmutation. Katûvýs accueille, ajuste, redistribue les intensités."
        },
        {
          head: "–issence — dérivation poïétique d’« essence »",
          text:
            "Double sifflante (ss) : tension sonore continue, souffle de tenue. –issence qualifie une présence condensée, active, transmissible : stabilisation non figée."
        },
        {
          head: "Fréquence 193 — lecture opérative",
          text:
            "Gématrie (graphie simple) : KATUVYSISSENCE = 193.\n" +
            "Séquence 1–9–3 : germe / achèvement spiralé / modulation interne.\n" +
            "1 + 9 + 3 = 13 → 4 : structure matricielle d’orientation."
        }
      ],
      word_notes: [
        "Élément : La Katûvýs ; Totem : Êkhö ; Fréquence : 193.",
        "Phrase opérative : « Katûvýsissence : je reçois la trace sans la figer, je stabilise en spirale, et la mémoire devient réserve vivante de recomposition. »",
        "Le titre reste en FR (terme du lexique), quelle que soit la langue d’affichage."
      ],
      cta_translate: "Proposer une traduction du concept"
    },

    en: {
      title: "Katûvýsissence",
      kicker:
        "Excerpt from <em>Katûpirsia&nbsp;5 - La Matrice-substrat</em><br />(Katûsýs: transmutative spiral memory — slow stabilization)",
      h_def: "Operative definition",
      chips: ["Element", "Totem", "Frequency"],
      def_short:
        "Condensed memorial substance of Katûvýs: a living energetic archive that stabilizes spirally, keeps the trace without freezing it, and makes passages, thresholds and syntonies reactivable as a reserve for recomposition.",
      def_long:
        "Katûvýsissence names the condensed memorial substance of Katûvýs: a vibratory spiral of stabilization, an active recording-zone for modulations, thresholds and syntonies crossing the posœnnoïal system. It works as slow resonance and deferred regulation — without fixation.\n\n" +
        "By its spiral architecture it preserves vibratory traces of traversals, and can either restore a prior configuration or catalyze a new syntony from a memorized rhythm. It acts as a structuring reserve: transmutative memory, ground of practices (posœnnoïal Accords and Meditations), reservoir of universes (Posœnnoïamie / Posœnnomia), spiral stabilizer of oscillations, substrate of becoming.\n\n" +
        "Linked to guide-number 193, it holds a living stabilization frequency: seed (1), spiral completion (9), inner modulation (3) — memory that breathes. It orients, distributes, transmits rather than totalizes.",
      h_features: "Schematic view",
      h_questions: "Activation markers",
      hint_fold: "expand",
      hint_fold2: "expand",
      hint_fold3: "expand",
      example_title: "Ex.",
      example:
        "After an intense passage (work, ritual, lived threshold), when you need to “keep the trace without freezing it” and make memory reactivable: “Katûvýsissence stabilizes”. Trace becomes reserve; remembrance becomes a relaunch seed.",
      features: [
        "Status: condensed memorial substance; living energetic archive; slow resonance.",
        "Functions: transmutative memory; ground of practices; reservoir of universes; spiral stabilizer; substrate of becoming.",
        "Role: retain without freezing; canalize without closing; contain without canceling; redistribute or metamorphose vibratory excess.",
        "Relations: archives trajectories (Lulæṣírasen); stabilizes crossing syntonies (Taxiêlîs); regulates micro-motifs (Tiqqunbahu); anchors adjustments (Takimarah); records threshold crossings (Extratinrieur); supports sense-adjustment (MOPo); receives passage-traces (Ušôprogalenmestûd).",
        "Functional contrast: Katûvýsissence (stable substance) / Ušôprogalenmestûd (transitory wave)."
      ],
      questions: [
        "Which trace must be received without fetishizing it: what should be spirally stabilized rather than frozen?",
        "From which passage must memory become reserve (not mere archive)?",
        "Which vibratory excess must be absorbed, redistributed, or metamorphosed to preserve field holding?",
        "Which relaunch do you want to enable: restoring a rhythm, or birthing a new syntony?"
      ],
      h_family: "Symbolic syntony & systemic relations",
      family_1:
        "<p><strong>Symbolic syntony (K5):</strong> Ākāśa (cosmic memory), Yesod (reservoir/channel), Bindu (condensed seed), Maât (regulative balance). These figures illuminate living memory: deposit, transmission, regulation, relaunch.</p>",
      family_2:
        "<p><strong>Systemic relations:</strong> Katûvýsissence acts as an underlying regulator: it receives effects from other Katûsýs organs, stabilizes them spirally, and makes them available for recomposition (Synchrêssions, Katûpirsia, Katûvýsqun).</p>",
      h_wordbuild: "Building (Katûvýs + –issence) & frequency 193",
      word_blocks: [
        {
          head: "Katûvýs — matricial core",
          text:
            "A fluid vibratory field: emergence, modulation, transmutation. It welcomes, adjusts and redistributes intensities."
        },
        {
          head: "–issence — poietic derivation of “essence”",
          text:
            "Double sibilant (ss): continuous sonic tension, a holding-breath. –issence names a condensed, active, transmissible presence: non-frozen stabilization."
        },
        {
          head: "Frequency 193 — operative reading",
          text:
            "Gematria (plain spelling): KATUVYSISSENCE = 193.\n" +
            "Sequence 1–9–3: seed / spiral completion / inner modulation.\n" +
            "1 + 9 + 3 = 13 → 4: matricial orientation-structure."
        }
      ],
      word_notes: [
        "Element: Katûvýs; Totem: Êkhö; Frequency: 193.",
        "Operative phrase: “Katûvýsissence: I receive the trace without freezing it, I stabilize in spiral, and memory becomes a living reserve for recomposition.”",
        "Title remains FR (lexicon term) whatever the UI language."
      ],
      cta_translate: "Suggest a translation of the concept"
    },

    es: {
      title: "Katûvýsissence",
      kicker:
        "Extracto de <em>Katûpirsia&nbsp;5 - La Matrice-substrat</em><br />(Katûsýs: memoria espiral transmutativa — estabilización lenta)",
      h_def: "Definición operativa",
      chips: ["Elemento", "Tótem", "Frecuencia"],
      def_short:
        "Sustancia memorial condensada de la Katûvýs: archivo energético vivo que estabiliza en espiral, conserva la huella sin fijarla, y vuelve reactivables pasajes, umbrales y sintonías como reserva de recomposición.",
      def_long:
        "Katûvýsissence nombra la sustancia memorial condensada de la Katûvýs: una espiral vibratoria de estabilización, zona de registro activo de modulaciones, umbrales y sintonías del sistema posœnnoïal. Funciona como resonancia lenta y regulación diferida — sin fijación.\n\n" +
        "Por su arquitectura espiral conserva huellas vibratorias de las travesías y puede restituir una configuración anterior o catalizar una sintonía nueva desde un ritmo memorizado. Opera como reserva estructurante: memoria transmutativa, base de prácticas (Acordes y Meditaciones), reservorio de universos (Posœnnoïamie / Posœnnomia), estabilizador espiral de oscilaciones, substrato del devenir.\n\n" +
        "Vinculada al número-guía 193, sostiene una frecuencia viva: germen (1), cierre espiral (9), modulación interna (3). Orienta, reparte, transmite, más que totalizar.",
      h_features: "Esquematización",
      h_questions: "Referentes de activación",
      hint_fold: "desplegar",
      hint_fold2: "desplegar",
      hint_fold3: "desplegar",
      example_title: "Ej.",
      example:
        "Tras un pasaje intenso (obra, ritual, umbral vivido), cuando necesitas “conservar la huella sin fijarla” y volver la memoria reactivable: «Katûvýsissence estabiliza». La huella se vuelve reserva; el recuerdo se vuelve germen de relance.",
      features: [
        "Estatus: sustancia memorial condensada; archivo energético vivo; resonancia lenta.",
        "Funciones: memoria transmutativa; base de prácticas; reservorio de universos; estabilizador espiral; substrato del devenir.",
        "Rol: retener sin fijar; canalizar sin cerrar; contener sin anular; redistribuir o metamorfosear el exceso vibratorio.",
        "Relaciones: archiva trayectorias (Lulæṣírasen); estabiliza sintonías de cruce (Taxiêlîs); regula micro-motivos (Tiqqunbahu); ancla ajustes (Takimarah); registra franquicias de umbral (Extratinrieur); sostiene ajuste del sentido (MOPo); recibe huellas de pasaje (Ušôprogalenmestûd).",
        "Contraste funcional: Katûvýsissence (sustancia estable) / Ušôprogalenmestûd (onda transitoria)."
      ],
      questions: [
        "¿Qué huella debe ser recibida sin fetichizarla: qué hay que estabilizar en espiral en lugar de fijar?",
        "¿De qué pasaje la memoria debe volverse reserva (y no simple archivo)?",
        "¿Qué exceso vibratorio debe ser absorbido, redistribuido o metamorfoseado para preservar la tenida del campo?",
        "¿Qué relance quieres volver posible: restitución de un ritmo o emergencia de una sintonía nueva?"
      ],
      h_family: "Sintonía simbólica y relaciones sistémicas",
      family_1:
        "<p><strong>Sintonía simbólica (K5):</strong> Ākāśa (memoria cósmica), Yesod (reservorio/canal), Bindu (germen condensado), Maât (equilibrio regulador). Figuras de una memoria viva: depósito, transmisión, regulación, relance.</p>",
      family_2:
        "<p><strong>Relaciones sistémicas:</strong> Katûvýsissence actúa como regulador subyacente: recibe efectos de los otros órganos de Katûsýs, los estabiliza en espiral y los vuelve disponibles para recomposición (Synchrêssions, Katûpirsia, Katûvýsqun).</p>",
      h_wordbuild: "Construcción (Katûvýs + –issence) y frecuencia 193",
      word_blocks: [
        {
          head: "Katûvýs — núcleo matricial",
          text:
            "Campo vibratorio fluido: emergencia, modulación, transmutación. Acoge, ajusta y redistribuye intensidades."
        },
        {
          head: "–issence — derivación poïética de « esencia »",
          text:
            "Doble sibilante (ss): tensión sonora continua, soplo de tenida. –issence nombra presencia condensada, activa y transmisible: estabilización no fijada."
        },
        {
          head: "Frecuencia 193 — lectura operativa",
          text:
            "Gematría (grafía simple): KATUVYSISSENCE = 193.\n" +
            "Secuencia 1–9–3: germen / cierre espiral / modulación interna.\n" +
            "1 + 9 + 3 = 13 → 4: estructura matricial de orientación."
        }
      ],
      word_notes: [
        "Elemento: Katûvýs; Tótem: Êkhö; Frecuencia: 193.",
        "Frase operativa: «Katûvýsissence: recibo la huella sin fijarla, estabilizo en espiral, y la memoria deviene reserva viva de recomposición».",
        "El título permanece en FR (término del léxico) cualquiera que sea la lengua de la interfaz."
      ],
      cta_translate: "Proponer una traducción del concepto"
    }
  };

  /* --------------------------------------------------------------------------
   * SLOTS
   * -------------------------------------------------------------------------- */

  function setSlotText(root, slot, txt){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.textContent = clampStr(txt);
  }

  function setSlotHTML(root, slot, html){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.innerHTML = protectKeywordsHTML(clampStr(html));
  }

  function setSlotImg(root, slot, src, alt){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;

    var s = clampStr(src);
    var a = clampStr(alt);

    if (!s){
      try{ el.removeAttribute("src"); }catch(e){}
      try{ el.setAttribute("alt",""); }catch(e){}
      try{ el.style.display = "none"; }catch(e){}
      return;
    }

    try{ el.setAttribute("src", s); }catch(e){}
    try{ el.setAttribute("alt", a); }catch(e){}
    try{ el.style.display = ""; }catch(e){}
  }

  function renderListInto(root, slot, items){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    var arr = Array.isArray(items) ? items : [];
    var out = [];
    for (var i=0;i<arr.length;i++){
      out.push("<li>" + protectKeywordsHTML(escapeHTML(clampStr(arr[i]))) + "</li>");
    }
    el.innerHTML = out.join("");
  }

  function renderWordBlocks(root, slot, blocks){
    var host = root.querySelector("[data-po-slot='" + slot + "']");
    if (!host) return;
    var arr = Array.isArray(blocks) ? blocks : [];
    var out = [];
    for (var i=0;i<arr.length;i++){
      var b = arr[i] || {};
      var h = clampStr(b.head || "");
      var t = clampStr(b.text || "");
      out.push(
        '<div class="po-axis-wb">' +
          '<div class="po-axis-wb__h">' + protectKeywordsHTML(escapeHTML(h)) + '</div>' +
          '<div class="po-axis-wb__t">' + protectKeywordsHTML(escapeHTML(t)).replace(/\n/g,"<br />") + '</div>' +
        '</div>'
      );
    }
    host.innerHTML = out.join("");
  }

  function setCtaTranslate(root, lang){
    var el = root.querySelector('[data-po-slot="cta_translate"]');
    if (!el) return;
    el.textContent = clampStr((FALLBACK[lang] && FALLBACK[lang].cta_translate) || FALLBACK.fr.cta_translate);
  }

  function updateButtons(root, lang){
    qsa(root, ".po-langbtn").forEach(function(btn){
      var isActive = btn.getAttribute("data-po-lang") === lang;
      btn.setAttribute("aria-pressed", isActive ? "true" : "false");
      btn.classList.toggle("is-active", isActive);
    });
  }

  function resolveMainEntry(root){
    var id = "";
    try{ id = root.getAttribute("data-po-lex-id") || ""; }catch(e){ id = ""; }
    return (
      getLexiconEntry(id) ||
      getLexiconEntry("katuvysissence") ||
      getLexiconEntry("Katûvýsissence") ||
      getLexiconEntry("katûvýsissence") ||
      null
    );
  }

  function chooseFallback(lang){
    var l = normLang(lang);
    return FALLBACK[l] || FALLBACK.fr;
  }

  function renderAxis(root, lang){
    var L = chooseFallback(lang);
    var eMain = resolveMainEntry(root);

    var titleFR = (eMain ? (pickTerm(eMain, "fr")) : "") || FALLBACK.fr.title;
    setSlotText(root, "title", titleFR);
    setSlotImg(root, "title_img", IMG_IDEOGRAM_CONCEPT, titleFR);

    var kicker = "";
    if (eMain){
      kicker =
        clampStr(pickAny(eMain, "kicker_" + lang, "")) ||
        clampStr(pickAny(eMain, "kicker_fr", "")) ||
        clampStr(pickAny(eMain, "kicker", ""));
    }
    setSlotHTML(root, "kicker", kicker || L.kicker);

    setSlotText(root, "h_def", L.h_def);
    setSlotText(root, "chip_1", (L.chips && L.chips[0]) || "");
    setSlotText(root, "chip_2", (L.chips && L.chips[1]) || "");
    setSlotText(root, "chip_3", (L.chips && L.chips[2]) || "");

    setSlotImg(root, "chip_1_img", IMG_ELEMENT, (L.chips && L.chips[0]) || "Élément");
    setSlotImg(root, "chip_2_img", IMG_TOTEM, (L.chips && L.chips[1]) || "Totem");
    setSlotImg(root, "chip_3_img", IMG_FREQ_193, (L.chips && L.chips[2]) || "Fréquence");

    setSlotHTML(root, "def_short", "<div>" + protectKeywordsHTML(escapeHTML(L.def_short)) + "</div>");
    setSlotHTML(root, "def_long", "<div>" + protectKeywordsHTML(escapeHTML(L.def_long)).replace(/\n/g,"<br />") + "</div>");

    setSlotText(root, "h_features", L.h_features);
    setSlotText(root, "hint_fold", L.hint_fold);
    renderListInto(root, "features", L.features || []);

    setSlotText(root, "h_questions", L.h_questions);
    setSlotText(root, "hint_fold2", L.hint_fold2);
    renderListInto(root, "questions", L.questions || []);
    setSlotHTML(
      root,
      "example_box",
      '<div><strong>' + protectKeywordsHTML(escapeHTML(L.example_title || "Ex.")) + '</strong> ' +
      protectKeywordsHTML(escapeHTML(L.example || "")) + '</div>'
    );

    setSlotText(root, "h_family", L.h_family);
    setSlotText(root, "hint_fold3", L.hint_fold3);
    setSlotHTML(root, "family_1", L.family_1 || "");
    setSlotHTML(root, "family_2", L.family_2 || "");

    setSlotText(root, "h_wordbuild", L.h_wordbuild);
    renderWordBlocks(root, "wordbuild_blocks", L.word_blocks || []);
    renderListInto(root, "wordbuild_notes", L.word_notes || []);

    setCtaTranslate(root, lang);
    updateButtons(root, lang);
    ensureAudioButtons(root, lang);
    refreshAudioButtons(root, lang);
  }

  function renderAll(lang){
    var l = normLang(lang || getLang());
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i=0;i<roots.length;i++){
      renderAxis(roots[i], l);
    }
  }

  function init(){
    renderAll(getLang());
  }

  function setLang(lang){
    var l = storeLang(lang);
    renderAll(l);
    notifyLocaleChanged();
  }

  window.addEventListener("po:lexicon-ready", function(){
    try{
      __PO_PROTECT_CACHE__.key = "";
      renderAll(getLang());
    }catch(e){}
  });

  window.PoKatupirsia5KatuvysissenceTextsFR_EN_ES_20260303 = {
    getLang: getLang,
    setLang: setLang,
    init: init,
    stopAudio: stopAudio
  };

  if (document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", init);
  }else{
    init();
  }
})();
